import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { setSessionStorageItem } from './sessionStorage';

/**
 * Hook to migrate a cookie value to sessionStorage and keep them in sync
 * This is used to transition from cookie-based storage to sessionStorage
 *
 * @param cookieName - The name of the cookie to migrate
 */
export const useCookieToSessionStorage = cookieName => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    // Check if there's a cookie value
    const cookieValue = Cookies.get(cookieName);
    if (cookieValue) {
      try {
        // Parse the cookie value if it's JSON
        const parsedValue = JSON.parse(cookieValue);

        // Store in sessionStorage
        setSessionStorageItem(cookieName, parsedValue);

        // Remove the cookie after migration
        Cookies.remove(cookieName, {
          path: '/'
        });
      } catch (error) {
        // If parsing fails, store as string
        setSessionStorageItem(cookieName, cookieValue);
        Cookies.remove(cookieName, {
          path: '/'
        });
      }
    }
  }, [cookieName]);
};